// @ts-expect-error TS(7006): Parameter 'state' implicitly has an 'any' type.
const getModalCurrentStep = (state) => state.modal.currentStep;

export default getModalCurrentStep;
